import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { getLocalKey } from "../../../../utils/commonfunction";
import { GetMGImages, GetMGModules } from "../../services/website.services";
import Skeleton from "react-loading-skeleton";

function ManualGuideDetails() {
  const { t } = useTranslation();
  const param = useParams();
  const location = useLocation();
  const [childModuleData, setChildModuleData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [images, setImages] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(Number(queryParams.get("i")));
    setDataLoaded(false);
    GetMGImages(param.slug, param.moduleSlug).then((response) => {
      if (response.success) {
        setImages(response.data);
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => { setDataLoaded(true) });
  }, [location , getLocalKey("system_language")]);

  useEffect(() => {
    GetMGModules(param.slug, param.moduleSlug).then((response) => {
      if (response.success) {
        setChildModuleData(response.data);
      }
    }).catch((err) => {
      console.error(err);
    });
  }, [getLocalKey("system_language") , location]);

  return (
    <>
      <div>
        <h4 className="mb-4 pb-3">{index+1}. {t(childModuleData?.title)}</h4>
        {
          !dataLoaded ? (<div>


         <Skeleton className={"d-block rounded-4 mx-3"} height={300} count={4} />


          </div>):
       
        <div className={"img-screen-box"+` ${param.slug}`}>
          {images?.map((item, ind) => {
            return (
              <div key={ind} className="img-screen-box-in">
                <h3>{index+1}.{ind+1} {t(item.title)}</h3>
                <figure>
                {item?.image ? <img className="border rounded-3" style={{maxWidth:"100%"}} src={item?.image} alt={item?.title} /> : ""}
                </figure>
              </div>
            );
          })}
        </div>
         }
      </div>
    </>
  );
}

export default ManualGuideDetails;
